import { template } from "lodash";

class SearchUtils {
  static likeFilters = ['like', 'not like'];

  static buildFromAdvancedSearch(advancedSearch, operators) {
    let searchTxt = "";
    advancedSearch.forEach(criteria => {
      if (criteria.key.trim().length != 0) {
        if (searchTxt.length > 0) {
          searchTxt += ",";
        }

        searchTxt += criteria.key;

        if (criteria.dataType != "") {
          searchTxt += "(" + criteria.dataType + ")";
        }

        if (operators.indexOf(criteria.operator) != -1) {
          searchTxt += "'" + criteria.operator + "'";
        } else {
          searchTxt += criteria.operator;
        }

        if (this.likeFilters.includes(criteria.operator)) {
          searchTxt += `%${criteria.value}%`;
        }
        else {
          searchTxt += criteria.value;
        }
      }
    });
    return searchTxt;
  }

  static parseAdvancedSearchFromString(searchTxt, operators, specialOperators) {
    const allOperators = operators.map((operator => {
      return specialOperators.indexOf(operator) == -1 ?
        operator :
        `'${operator}'`;
    }));
    const regex = new RegExp(`(.+)(${allOperators.join('|')})(.+)`);

    let advancedSearch = [];
    searchTxt.split(',').forEach(term => {
      let terms = term.match(regex);
      // Skip invalid parameters
      if (!terms || terms.length != 4)
        return;

      let criteria = {
        key: terms[1].replace(/\(.+\)/, ''),
        operator: terms[2].replace(/'/g, ''),
        value: terms[3],
        dataType: '',
      };

      // Removes default percentage character
      if (this.likeFilters.includes(criteria.operator)) {
        criteria.value = criteria.value.replace(/^\%|%$/g, '');
      }

      // Get type
      let dataType = terms[1].match(/\((.+)\)/);
      if (dataType)
        criteria.dataType = dataType[1];

      advancedSearch.push(criteria);
    });

    return advancedSearch;
  }

  static buildFromSimpleSearch(simpleSearch, keys) {
    const params = simpleSearch.reduce(
      (filters, value, index) => {
        if (value)
          filters.push(keys[index] + "'like'%" + value + "%");
        return filters;
      },
      []);
    return params.join(',');
  }
}

export default SearchUtils;
